<div class="flex flex-col gap-8">
  <div class="flex flex-col w-[328px] h-auto border border-[#F1F1F1] p-4 rounded-[20px] text-kaz-black-text gap-3">
    <span class="text-base font-semibold">Schnellsuche</span>
    <!-- Divider -->
    <div class="h-[1px] bg-[#EFEFEF]"></div>
    @for (cat of getCategoryList(); track cat) {
      <div>
        <div class="grid grid-cols-[1fr_auto]">
          <a routerLink="/entry/search" [queryParams]="{ search: cat }"
          class="text-sm font-semibold hover:text-kaz-orange">{{ cat }}</a>
          @if (isExpandable(cat)) {
            <fa-icon class="px-5 text-kaz-blue md:hover:text-kaz-orange md:cursor-pointer"
              [icon]="showList(cat) ? 'chevron-up' : 'chevron-down'" [title]="showList(cat) ? 'weniger' : 'mehr'"
            (click)="changeActiveState(cat)"></fa-icon>
          }
        </div>
        @if (showList(cat)) {
          <div class="flex flex-col indent-4">
            @for (sub of getFilteredSubCategory(cat); track sub) {
              <div>
                <div class="grid grid-cols-[1fr_auto]">
                  <a routerLink="/entry/search" [queryParams]="{ search: sub.name }"
                  class="text-sm font-normal hover:text-kaz-orange">{{ sub.name }}</a>
                  @if (isExpandable(sub.name)) {
                    <fa-icon class="px-5 text-kaz-blue md:hover:text-kaz-orange md:cursor-pointer"
                      [icon]="showLocality ? 'chevron-up' : 'chevron-down'"
                      [title]="showLocality ? 'weniger' : 'mehr'"
                    (click)="changeActiveState(sub.name)"></fa-icon>
                  }
                </div>
                @if (sub.name === 'Vermietungen' && showLocality) {
                  <div class="flex flex-col indent-8">
                    @for (locality of localityList; track locality) {
                      <div>
                        <a routerLink="/entry/search" [queryParams]="{ search: locality }"
                        class="text-sm font-normal hover:text-kaz-orange">{{ locality }}</a>
                      </div>
                    }
                  </div>
                }
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  <!-- medium rectangle -->
  <!--  <kaz-smart-entry class="flex flex-row justify-center items-center h-72" [type]="SmartAdType.RECTANGLE"></kaz-smart-entry>-->
  <kaz-button-feedback />
</div>
